export const paymentConstants = {
    bookingFee : 10
}
